<template>
  <table class="table">
    <tbody>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.name') }}:</strong>
          </h6>
          {{ calendarData.name }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.associated_farms') }}:</strong>
          </h6>
          <span v-for="(farm, index) in calendarData.farms" :key="index">
            <el-tag type="info">{{ farm.name }}</el-tag>
          </span>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.associated_companies') }}:</strong>
          </h6>
          <span
            v-for="(business, index) in calendarData.businesses"
            :key="index"
          >
            <el-tag type="info">{{ business.name }}</el-tag>
          </span>
        </td>
      </tr>
      <tr class="shadow-sm" v-if="calendarData.years">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.calendar_detailof') }}:</strong>
          </h6>
          <select-component
            :isMultiple="false"
            :dataOptions="calendarData.years"
            :initialSelection="yearSel"
            :labelSelect="`${$t('common_words.year_selection')}:`"
            :rowClass="'d-flex justify-content-center col-12'"
            :valueOption="`year`"
            @onChange="loadCalendar"
          />
          <div v-if="calendarData" style="border: none">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="text-center">
                    {{ selectedPeriodicityDetails.name }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t('common_words.beginning') }}
                    {{ selectedPeriodicityDetails.article }}
                    {{ selectedPeriodicityDetails.name.toLowerCase() }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t('common_words.end') }}
                    {{ selectedPeriodicityDetails.article }}
                    {{ selectedPeriodicityDetails.name.toLowerCase() }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="isCreateOrEdit">
                <tr
                  v-for="(initDate, index) in calendarData.init_dates_week[
                    yearSel
                  ]"
                  :key="index"
                >
                  <td>
                    <p class="text-center">
                      {{ index + 1 }}
                    </p>
                  </td>
                  <td>
                    <p class="text-center">
                      {{ formatDateWeek(initDate) }}
                    </p>
                  </td>
                  <td>
                    <p class="text-center">
                      {{
                        formatDateWeek(
                          calendarData.end_dates_week[yearSel][index]
                        )
                      }}
                    </p>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(period, index) in details" :key="period.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">
                    {{ period.init_date_week }}
                  </td>
                  <td class="text-center">
                    {{ period.end_date_week }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center">
            <p>
              {{ $t('common_words.calendar_selected_info') }}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import moment from 'moment';

export default {
  name: 'payment-calendar-details-table',
  props: {
    calendarData: {
      type: Object,
      default: null,
    },
    isCreateOrEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      yearSel: null,
      details: null,
      periocity: null,
    };
  },

  watch: {
    calendarData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.years && newVal.years.length > 0) {
          const yearData = newVal.years[newVal.years.length - 1];
          if (this.isCreateOrEdit) {
            this.yearSel = this.calendarData.yearSel;
            this.periocity = this.calendarData.periocity[this.yearSel];
          } else {
            this.details = Array.isArray(yearData.details)
              ? yearData.details
              : [];
            this.periocity = yearData.periocity;
            this.yearSel = yearData.year;
          }
        } else {
          this.details = [];
          this.periocity = null;
          this.yearSel = null;
        }
      },
    },
  },

  computed: {
    selectedPeriodicityDetails() {
      const mapping = {
        7: {
          name: this.$i18n.t('common_words.week'),
          article: this.$i18n.t('common_words.of_the'),
        },
        14: {
          name: this.$i18n.t('common_words.fortnight_14'),
          article: this.$i18n.t('common_words.of_the'),
        },
        15: {
          name: this.$i18n.t('common_words.fortnight_15'),
          article: this.$i18n.t('common_words.of_the'),
        },
        30: {
          name: this.$i18n.t('common_words.month'),
          article: this.$i18n.t('common_words.from_the'),
        },
        0: {
          name: this.$i18n.t('common_words.period'),
          article: this.$i18n.t('common_words.from_the'),
        },
      };

      const cycle = Number(this.periocity);

      return (
        mapping[cycle] || {
          name: this.$i18n.t('common_words.period'),
          article: this.$i18n.t('common_words.from_the'),
        }
      );
    },
  },

  methods: {
    formatDateWeek(date_week) {
      return moment(date_week).format('YYYY-MM-DD');
    },

    loadCalendar(data) {
      this.$set(this, 'yearSel', data.selects);
      const yearData = this.calendarData.years.find(
        (y) => y.year == Number(data.selects)
      );

      if (yearData) {
        if (this.isCreateOrEdit) {
          this.periocity = this.calendarData.periocity[this.yearSel];
        } else {
          this.details = Array.isArray(yearData.details)
            ? yearData.details
            : [];
          this.periocity = yearData.periocity;
        }
      } else {
        this.details = [];
        this.periocity = null;
      }
    },
  },
};
</script>
